module.exports = __webpack_public_path__ + "img/interface.68d93df9.jpg";